import React, { useEffect, useRef, useState, useMemo } from 'react';
// import {
//   AcceptButton,
//   BottomCaption,
//   CancelButton,
//   CaptionEditButtons
// } from './styles'
// import useLocalization from '../../../../../hooks/useLocalization'
import { AcceptButton, BottomCaption, CancelButton, CaptionEditButtons } from '../../editor/CaptionEdit/styles';
import useLocalization from '../../../../../hooks/useLocalization';
var MultipleCaptionEdit = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, onCancel = _a.onCancel, isMultiLoad = _a.isMultiLoad, visible = _a.visible, clear = _a.clear;
    var ref = useRef();
    var _b = useState(value), text = _b[0], setText = _b[1];
    var _c = useState(false), collapse = _c[0], setCollapse = _c[1];
    var t = useLocalization().t;
    useEffect(function () {
        ref.current.focus();
    }, []);
    useEffect(function () {
        if (isMultiLoad && clear && ref) {
            ref.current.value = '';
            setText('');
        }
    }, [clear, isMultiLoad, ref]);
    useEffect(function () {
        if (collapse) {
            setTimeout(function () { return setCollapse(false); }, 500);
        }
    }, [collapse]);
    useEffect(function () {
        if (isMultiLoad && (value === null || value === void 0 ? void 0 : value.length)) {
            setText(value);
        }
    }, [value, isMultiLoad]);
    var handleChange = function (_a) {
        var value = _a.target.value;
        setText(value);
        if (isMultiLoad) {
            onSubmit && onSubmit(value);
        }
    };
    var handleSubmit = function () {
        onSubmit && onSubmit(text);
        setCollapse(true);
    };
    if (isMultiLoad) {
        return (React.createElement(BottomCaption, { className: 'capt', isMultiLoad: true },
            React.createElement("input", { type: 'text', value: text, ref: ref, onChange: handleChange, placeholder: t('editor.add_caption_placeholder_multi'), maxLength: '200' })));
    }
    return (React.createElement(BottomCaption, { className: 'capt' },
        React.createElement("input", { type: 'text', value: text, ref: ref, onChange: handleChange, placeholder: t('editor.add_caption_placeholder'), maxLength: '200' }),
        React.createElement(CaptionEditButtons, null,
            React.createElement(AcceptButton, { onClick: handleSubmit }),
            React.createElement(CancelButton, { onClick: onCancel }))));
};
export default MultipleCaptionEdit;
//# sourceMappingURL=MultipleCaptionEdit.js.mapimport React, { useEffect, useRef, useState, useMemo } from 'react';
// import {
//   AcceptButton,
//   BottomCaption,
//   CancelButton,
//   CaptionEditButtons
// } from './styles'
// import useLocalization from '../../../../../hooks/useLocalization'
import { AcceptButton, BottomCaption, CancelButton, CaptionEditButtons } from '../../editor/CaptionEdit/styles';
import useLocalization from '../../../../../hooks/useLocalization';
var MultipleCaptionEdit = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, onCancel = _a.onCancel, isMultiLoad = _a.isMultiLoad, visible = _a.visible, clear = _a.clear;
    var ref = useRef();
    var _b = useState(value), text = _b[0], setText = _b[1];
    var _c = useState(false), collapse = _c[0], setCollapse = _c[1];
    var t = useLocalization().t;
    useEffect(function () {
        ref.current.focus();
    }, []);
    useEffect(function () {
        if (isMultiLoad && clear && ref) {
            ref.current.value = '';
            setText('');
        }
    }, [clear, isMultiLoad, ref]);
    useEffect(function () {
        if (collapse) {
            setTimeout(function () { return setCollapse(false); }, 500);
        }
    }, [collapse]);
    useEffect(function () {
        if (isMultiLoad && (value === null || value === void 0 ? void 0 : value.length)) {
            setText(value);
        }
    }, [value, isMultiLoad]);
    var handleChange = function (_a) {
        var value = _a.target.value;
        setText(value);
        if (isMultiLoad) {
            onSubmit && onSubmit(value);
        }
    };
    var handleSubmit = function () {
        onSubmit && onSubmit(text);
        setCollapse(true);
    };
    if (isMultiLoad) {
        return (React.createElement(BottomCaption, { className: 'capt', isMultiLoad: true },
            React.createElement("input", { type: 'text', value: text, ref: ref, onChange: handleChange, placeholder: t('editor.add_caption_placeholder_multi'), maxLength: '200' })));
    }
    return (React.createElement(BottomCaption, { className: 'capt' },
        React.createElement("input", { type: 'text', value: text, ref: ref, onChange: handleChange, placeholder: t('editor.add_caption_placeholder'), maxLength: '200' }),
        React.createElement(CaptionEditButtons, null,
            React.createElement(AcceptButton, { onClick: handleSubmit }),
            React.createElement(CancelButton, { onClick: onCancel }))));
};
export default MultipleCaptionEdit;
//# sourceMappingURL=MultipleCaptionEdit.js.map